
import en from './en';
import cn from './cn';
import tw from './tw';
export default {
    en: en,
    cn: cn,
    tw: tw
}


// WEBPACK FOOTER //
// ./src/i18n/langs/index.js